import * as Charts from './chart';

let frappe     = { };

frappe.NAME    = 'Frappe Charts';
frappe.VERSION = '1.4.1';

frappe         = Object.assign({ }, frappe, Charts);

export default frappe;